// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a90a800f","667":"b040b467","977":"7bcfb3c6"}[chunkId] + ".chunk.js";
};